import { DialogV2, Loader, Typography } from '@recruit-robin/robin-theme/web-components';
import { Star_06 } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useStyles } from './LoadingRjCommDialog.styles';
import { LoadingRjCommDialogProps } from './LoadingRjCommDialog.types';

export const LoadingRjCommDialog = ({ isVisible, title }: LoadingRjCommDialogProps) => {
  const classes = useStyles({});
  const { dictionary } = useContext(LocalizationContext);

  return (
    <DialogV2.Root isVisible={isVisible} customCss={classes.dialog}>
      <DialogV2.Backdrop />
      <DialogV2.Content>
        <DialogV2.Header customCss={classes.title}>
          <Star_06 size={24} color={(c) => c.primary.fuchsia[40]} />
          <Typography variant={(v) => v.heading[3]} color={(c) => c.neutral.variant[80]}>
            {title || dictionary.robinJrIsAnalysingYourVacancy}
          </Typography>
        </DialogV2.Header>
        <DialogV2.Body>
          <div css={classes.loader}>
            <Loader size={64} />
          </div>
        </DialogV2.Body>
      </DialogV2.Content>
    </DialogV2.Root>
  );
};
